import { render, staticRenderFns } from "./otpForm.vue?vue&type=template&id=0c6f1241&scoped=true&"
import script from "./otpForm.vue?vue&type=script&lang=babel&"
export * from "./otpForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f1241",
  null
  
)

export default component.exports